import { useId } from "react";

function Loader({ className, color = "#5F6367", id }) {
  // Every instance needs its OWN gradient id. With a shared default, several mounted
  // loaders emit duplicate ids and each one's stroke="url(#id)" resolves to whichever
  // gradient is first in the document — so a loader rendered with color="white"
  // elsewhere on the page repaints this one's rotating arc white-on-white, leaving
  // only the static ring and making the spinner look frozen.
  const uniqueId = useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const gradientId = id || `loader-${uniqueId}`;
  return (
    <div className={`loader ${className}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <radialGradient id={gradientId} cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
          <stop offset="0" stopColor={color}></stop>
          <stop offset=".3" stopColor={color} stopOpacity=".9"></stop>
          <stop offset=".6" stopColor={color} stopOpacity=".6"></stop>
          <stop offset=".8" stopColor={color} stopOpacity=".3"></stop>
          <stop offset="1" stopColor={color} stopOpacity="0"></stop>
        </radialGradient>
        <circle
          transformOrigin="center"
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth="15"
          strokeLinecap="round"
          strokeDasharray="200 1000"
          strokeDashoffset="0"
          cx="100"
          cy="100"
          r="70"
        >
          <animateTransform
            type="rotate"
            attributeName="transform"
            calcMode="spline"
            dur="2"
            values="360;0"
            keyTimes="0;1"
            keySplines="0 0 1 1"
            repeatCount="indefinite"
          ></animateTransform>
        </circle>
        <circle
          transformOrigin="center"
          fill="none"
          opacity=".2"
          stroke={color}
          strokeWidth="15"
          strokeLinecap="round"
          cx="100"
          cy="100"
          r="70"
        ></circle>
      </svg>
    </div>
  );
}

export default Loader;
